import { Seperator } from "./Seperator";

export function Divider() {
    return <Seperator />;
}
